import { Injectable } from '@angular/core';
import { ApiHttpService } from './api-http.service';
import { CustomerResponse } from '../../shared/models/customer';
import { IApiResponse } from '../../shared/models/api';

export interface CustomerDropdown {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  isVerified: boolean;
  status: string;
}

@Injectable({
  providedIn: 'root',
})
export class CustomerService {
  constructor(private http: ApiHttpService) {}

  getCustomers(page: number = 1, limit: number = 10) {
    return this.http.get(`user/customers?page=${page}&limit=${limit}`);
  }

  getCustomersDropdown() {
    return this.http.get(`user/customers/dropdown`);
  }

  deleteCustomer(customerId: string) {
    return this.http.delete(`user/${customerId}`);
  }
}
